// extracted by mini-css-extract-plugin
module.exports = {"root":"topbar_root__Ah_U4","logo":"topbar_logo__5CvkP"};